/* eslint-disable no-use-before-define */
const Storage = require('utils/localStorage/Storage');
const LOCAL_STORAGE = require('utils/localStorage/Constants');
const deepExtend = require('utils/deepExtend');

const AVAILABILITY = {
    OUT_OF_STOCK: 'Out of Stock',
    LIMITED_STOCK: 'Limited Stock',
    IN_STOCK: 'In Stock'
};

function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function deepMerge(target, ...sources) {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, { [key]: {} });
                }
                deepMerge(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return deepMerge(target, ...sources);
}

function mergeActionFlags(actionFlagsProduct = {}, actionFlagsRopis) {
    Object.assign(actionFlagsProduct, actionFlagsRopis);
}

function mergeCurrentSkuIntoChildSkus(childSkus, currentRopisSku) {
    if (childSkus) {
        let currentSku = childSkus.find(sku => sku.skuId === currentRopisSku.skuId);

        if (currentSku) {
            mergeActionFlags(currentSku.actionFlags, currentRopisSku.actionFlags);
            Object.assign(currentSku, currentRopisSku);
        }
    }
}


function mergeChildSkus(childSkus, ropisChildSkus) {
    if (childSkus && childSkus.length > 0) {
        let currentRopisSku;
        childSkus.forEach((currentSku) => {
            currentRopisSku = ropisChildSkus.find(sku => sku.skuId === currentSku.skuId);

            if (currentRopisSku) {
                mergeActionFlags(currentSku.actionFlags, currentRopisSku.actionFlags);
            }
            Object.assign(currentSku, currentRopisSku);
        });
    }
}

function mergeCurrentSku(regularProduct, ropisProduct) {
    mergeActionFlags(regularProduct.currentSku.actionFlags,
        ropisProduct.currentSku.actionFlags);
    deepMerge(regularProduct.currentSku, ropisProduct.currentSku);
    if (ropisProduct.pickupMessage) {
        regularProduct.pickupMessage = ropisProduct.pickupMessage;
    }
}

function findCurrentSkuInChildren(currentSkuId, childrenSkus) {
    if (childrenSkus) {
        return childrenSkus.find(sku => sku.skuId === currentSkuId);
    } else {
        return null;
    }

}

function getPreferredStoreName(user) {
    const store = require('store/Store');
    const { preferredStoreName } = user || store.getState().user;
    const selectedStore = Storage.session.getItem(LOCAL_STORAGE.SELECTED_STORE);
    if (preferredStoreName) {
        return preferredStoreName;
    }
    return selectedStore ? selectedStore.displayName : null;
}

let ReserveOnlinePickUpInStoreProductUtils = {
    getPreferredStoreName,

    removeReserveOnlinePickUpInStoreDetailsToProduct: function (productWithRopisDetails, previousProduct) {
        let currentSkuId = productWithRopisDetails.currentSku.skuId;

        let currentSku = findCurrentSkuInChildren(currentSkuId, previousProduct.regularChildSkus);

        if (!currentSku && previousProduct.ancillarySkus) {
            currentSku = findCurrentSkuInChildren(currentSkuId, previousProduct.ancillarySkus);
        }

        if (!currentSku && previousProduct.onSaleChildSkus) {
            currentSku = findCurrentSkuInChildren(currentSkuId, previousProduct.onSaleChildSkus);
        }

        if (currentSku) {
            previousProduct.currentSku = currentSku;
        }

        return previousProduct;
    },


    // This method adds Ropis specific details to currentProduct Object
    // for example currentSku, regularChildSkus, onSaleChildSkus and ancillarySkus
    // because this information will be pulled if the user chooses the Reserve Online
    // Pick Up In Store option in product page after initial cached product common
    // information is loaded in ctrlr
    addReserveOnlinePickUpInStoreDetailsToProduct: function (product, reserveOnlinePickUpInStoreProductDetails = {}) {
        let clonedProduct = deepExtend({}, product);
        mergeCurrentSku(clonedProduct, reserveOnlinePickUpInStoreProductDetails);

        if (reserveOnlinePickUpInStoreProductDetails.regularChildSkus) {
            mergeChildSkus(clonedProduct.regularChildSkus, reserveOnlinePickUpInStoreProductDetails.regularChildSkus);
        }
        // TODO: ancillarySkus correspond to «Use It With», so we are not updating it for now since Quick Look
        // stock availability is not being updated. Uncomment these lines when QuickLook product availability is updated
        // if (reserveOnlinePickUpInStoreProductDetails.ancillarySkus) {
        //     mergeChildSkus(clonedProduct.ancillarySkus, reserveOnlinePickUpInStoreProductDetails.ancillarySkus);
        // }
        if (reserveOnlinePickUpInStoreProductDetails.onSaleChildSkus) {
            mergeChildSkus(clonedProduct.onSaleChildSkus, reserveOnlinePickUpInStoreProductDetails.onSaleChildSkus);
        }

        // ROPIS API returns a list of childSkus excluding the current sku. We're traversing through the
        // skus to make sure the current sku gets merged with its ROPIS properties as well
        if (clonedProduct.regularChildSkus) {
            mergeCurrentSkuIntoChildSkus(clonedProduct.regularChildSkus,
                reserveOnlinePickUpInStoreProductDetails.currentSku);
        }

        if (clonedProduct.ancillarySkus) {
            mergeCurrentSkuIntoChildSkus(clonedProduct.ancillarySkus,
                reserveOnlinePickUpInStoreProductDetails.currentSku);
        }

        if (clonedProduct.onSaleChildSkus) {
            mergeCurrentSkuIntoChildSkus(clonedProduct.onSaleChildSkus,
                reserveOnlinePickUpInStoreProductDetails.currentSku);
        }

        clonedProduct = Object.assign(reserveOnlinePickUpInStoreProductDetails, clonedProduct);
        return clonedProduct;
    },

    isProductRopisUpdated: function (product) {
        return (product.pickupMessage === null);
    },

    isOutOfStock: function (availabilityStatus) {
        return availabilityStatus === AVAILABILITY.OUT_OF_STOCK;
    },

    isLimitedStock: function (availabilityStatus) {
        return availabilityStatus === AVAILABILITY.LIMITED_STOCK;
    },

    isinStock: function (availabilityStatus) {
        return availabilityStatus === AVAILABILITY.IN_STOCK;
    },

    availabilityLabel: function (availabilityStatus) {
        if (ReserveOnlinePickUpInStoreProductUtils.isOutOfStock(availabilityStatus)) {
            return 'outOfStock';
        } else {
            if (ReserveOnlinePickUpInStoreProductUtils.isLimitedStock(availabilityStatus)) {
                return 'limitedStock';
            } else {
                return 'inStock';
            }
        }
    },

    AVAILABILITY_STATUS: AVAILABILITY,

    mergeActionFlags,
    mergeChildSkus,
    mergeCurrentSku,
    mergeCurrentSkuIntoChildSkus,
    findCurrentSkuInChildren

};

module.exports = ReserveOnlinePickUpInStoreProductUtils;
